import { motion } from "motion/react";
import { isRed, rankOf, suitOf } from "../lib/cards.js";

interface Props {
  /** `null` — рубашка (карта соперника или колода). */
  card: number | null;
  /** Уменьшенный размер для стола и колоды. */
  small?: boolean;
  /** Приподнята и подсвечена — выбрана игроком. */
  selected?: boolean;
  /** Можно сыграть прямо сейчас. */
  playable?: boolean;
  /** Общий id для анимации перелёта между местами на столе. */
  layoutId?: string;
  onClick?(): void;
  style?: React.CSSProperties;
}

export function Card({ card, small, selected, playable, layoutId, onClick, style }: Props) {
  const cls = [
    "pcard",
    small ? "pcard-sm" : "",
    card === null ? "pcard-back" : "",
    selected ? "is-selected" : "",
    playable ? "is-playable" : "",
    card !== null && isRed(card) ? "is-red" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <motion.div
      {...(layoutId ? { layoutId } : {})}
      className={cls}
      style={style}
      onClick={onClick}
      // Перелёты карт: пружина даёт живое движение без «резинового» перелёта.
      transition={{ type: "spring", stiffness: 520, damping: 38, mass: 0.7 }}
      whileTap={playable ? { scale: 0.94 } : undefined}
    >
      {card !== null && (
        <>
          <span className="pcard-corner">
            {rankOf(card)}
            <em>{suitOf(card)}</em>
          </span>
          <span className="pcard-pip">{suitOf(card)}</span>
        </>
      )}
    </motion.div>
  );
}
